import React, { useEffect, useState } from 'react';
import Drawer from '@mui/material/Drawer';
import styled from "@mui/material/styles/styled";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';
import { Header } from './header';
import { Body } from './body';
import { Footer } from './footer';
import Proptypes from 'prop-types';

let drawerWidth = 420, initialAnchor = "right";

const StyledDrawer = styled(Drawer, {
    shouldForwardProp: prop => prop !== "width"
})(({ theme, width }) => ({
    '& .MuiPaper-root': {
        width,
    },
    color: "red"
}))

const CloseButtonWrapper = styled(IconButton)({
    borderRadius: 4,
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FFFFFF",
    '&:hover': {
        backgroundColor: "#FFFFFF",
    }
});

const FixedOutsideDrawer = styled('div', {
    shouldForwardProp: prop => prop !== "anchor" && prop !== "width"
})(({ theme, anchor, width }) => ({
    position: 'fixed',
    [anchor]: width,
    padding: theme.spacing(2)
}));

export const FilterGenerator = (props) => {

    const {
        open = false,
        onClose = null,
        onApply = null,
        anchor = initialAnchor,
        buttonName = "Apply",
        width = drawerWidth,
        components = [],
        clearStateonComponentChanges = true // if true it clears state while changing components from parent
    } = props;


    const [state, setState] = useState({
        data: {},
        components: []
    });

    const [error, setError] = useState(null);

    useEffect(() => {
        if (components?.length) {
            let updateState = { ...state?.data };
            if (clearStateonComponentChanges) {
                updateState = {};
            }
            components?.map(_ => {
                if (_?.state_name) {
                    updateState[_?.state_name] = _?.value;
                }
                return _
            })
            setState({
                ...state,
                data: updateState,
                components
            })
        }
        // eslint-disable-next-line
    }, [components])


    const onChangeState = (key, value, componentDetails) => {

        //construct dependency state while generate json props 
        let findDependency = state?.components?.find(_ => _?.state_name === componentDetails?.state_name);
        if (findDependency?.dependency && findDependency?.dependencyState?.length > 0) {
            findDependency?.dependencyState?.map(_ => {
                if (state?.data?.hasOwnProperty(_)) {
                    state.data[_] = ""
                }
                return _
            })
        }

        setState({
            ...state,
            data: {
                ...state.data, [key]: value
            }
        })
    }

    const onClearState = () => {
        setState({
            ...state,
            data: {}
        })
    }

    const onCloseDrawer = () => {
        onClearState();
        onClose()
    }

    const onApplyFilter = () => {

        if (!validation()) {
            onClose()
            onApply(state?.data)
            onClearState();
        }
    }


    const validation = () => {

        const errorState = {};

        const { data, components } = state;

        components?.map(_ => {
            if (_?.required) {
                if (
                    !data?.[_?.state_name] ||
                    //to check Object
                    (data?.[_?.state_name]?.constructor === Object && !Object?.keys(data?.[_?.state_name])?.length) ||
                    //to check Date
                    (data?.[_?.state_name]?.constructor === Date && !data?.[_?.state_name]) ||
                    //to check Array
                    (data?.[_?.state_name]?.constructor === Array && !data?.[_?.state_name]?.length) ||
                    //to check string
                    (data?.[_?.state_name]?.constructor === String && !data?.[_?.state_name]?.trim()?.length) ||
                    //to check particular components
                    (_?.component === "minMaxTextFieldWithSelect" &&
                        !Boolean(data?.[_?.state_name]?.min && data?.[_?.state_name]?.max && (_?.select ? data?.[_?.state_name]?.select : false)))
                ) {
                    errorState[_?.state_name] = true;
                }
            }
            return _
        })

        setError(errorState)
        return Boolean(Object.keys(errorState)?.length);
    }

    return (
        <div>
            <StyledDrawer
                width={width}
                anchor={anchor}
                open={open}
                onClose={onCloseDrawer}
            >
                <FixedOutsideDrawer
                    anchor={anchor}
                    width={width}
                >
                    <CloseButtonWrapper onClick={onCloseDrawer}>
                        <CloseIcon sx={{ color: "#7C8594" }} />
                    </CloseButtonWrapper>
                </FixedOutsideDrawer>
                <Stack
                    direction={"column"}
                    height={1}
                >
                    <Header
                        onClear={onClearState}
                    />
                    <Body
                        data={state?.data}
                        error={error}
                        components={state?.components}
                        onChangeState={onChangeState}
                    />
                    <Footer
                        buttonName={buttonName}
                        buttonAction={onApplyFilter}
                    />
                </Stack>
            </StyledDrawer>
        </div >
    )
}


FilterGenerator.propTypes = {
    open: Proptypes.bool,
    onClose: Proptypes.func,
    onApply: Proptypes.func,
    anchor: Proptypes.string,
    buttonName: Proptypes.string,
    width: Proptypes.string,
    components: Proptypes.array,
    clearStateonComponentChanges: Proptypes.bool
}